import { ReactNode } from "react";
import AccountTag from "../../model/AccountTag";

type Props = {
    accountTag: AccountTag,
    action?: ReactNode,
    onClick?: Function
}
const TagView = ({accountTag, action, onClick}: Props) => {

    const defaultClass = "account-tag";

    const invertColor = (color: string) => {
        let first = color.substring(0,1);
        let hex = (first == "#") ? color.substring(1) : color;
        let inv =(Number(`0x1${hex}`) ^ 0xFFFFFF).toString(16).substring(1).toUpperCase()
        return "#" + inv
    }

    const computeTagStyle = (accounTag: AccountTag) => {

        let borderColor = (accounTag.color.toUpperCase() == "#FFF" || accounTag.color.toUpperCase() == "#FFFFFF") ? "#CCCCCC" : accounTag.color;

        return {
            backgroundColor: accounTag.color, 
            border: `1px solid ${borderColor}`,
            color: invertColor(accounTag.color)
        };
    }

    const computeTagClass = (accounTag: AccountTag) => {
        //return (activeTag !== null && accounTag.name==activeTag) ? "active" : ""
        return defaultClass;
    }

    return (
        <span className={computeTagClass(accountTag)} 
              style={computeTagStyle(accountTag)}
              onClick={(e) => {
                if (onClick) {
                    onClick(accountTag)
                }
              }}>{accountTag.name} {action !== undefined ? action : ""}</span>
    )
}

export default TagView;